var _excluded = ["navigation"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { styled } from '@grupoboticario/flora-react-system';
import { ChevronRightIcon } from '@grupoboticario/flora-react-icons';
import React from 'react';
import { Flex } from '@grupoboticario/flora-react-flex';
import { Hidden } from '@grupoboticario/flora-react-hidden';
import { HouseIcon, ThreeDotsHorizontalIcon } from '@grupoboticario/flora-react-icons';
import { Box } from '@grupoboticario/flora-react';
var NewIconDots = styled(ThreeDotsHorizontalIcon);
var NewIconHome = styled(HouseIcon);
var StyledBreadcrumb = styled('ol', {
  display: 'flex',
  padding: 0,
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '$bodySmall',
  fontFamily: '$secondary',
  '& > li:not(:first-child):not(:nth-last-child(-n+2))': {
    display: 'none',
    '@tablet': {
      display: 'flex'
    }
  },
  variants: {
    variant: {
      standard: {
        li: {
          color: '$nonInteractivePredominant',
          a: {
            color: '$linkDefault',
            '&:hover': {
              color: '$linkHover',
              textDecoration: 'underline'
            }
          },
          div: {
            color: '$nonInteractiveAuxiliar'
          },
          ["" + NewIconDots]: {
            color: '$linkDefault',
            '&:hover': {
              color: '$linkHover'
            }
          }
        }
      },
      alt: {
        li: {
          color: '$nonInteractiveAltPredominant',
          span: {
            fontSize: 'bodySmall'
          },
          a: {
            color: '$linkAlt',
            '&:hover': {
              color: '$linkAltHover',
              textDecoration: 'underline'
            }
          },
          div: {
            color: '$nonInteractiveAltAuxiliar'
          },
          ["" + NewIconDots]: {
            color: '$linkAlt',
            '&:hover': {
              color: '$linkAltHover',
              textDecoration: 'underline'
            }
          }
        }
      }
    }
  },
  defaultVariants: {
    variant: 'standard'
  }
});
var BreadcrumbItem = styled('li', {
  display: 'flex',
  alignItems: 'center',
  truncationWidth: 'number',
  whiteSpace: 'nowrap',
  fontSize: '$bodySmall',
  fontFamily: '$secondary'
});
export var Breadcrumb = _ref => {
  var {
    navigation
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, {
    as: "nav",
    "aria-label": "Breadcrumb"
  }, /*#__PURE__*/React.createElement(StyledBreadcrumb, _extends({
    "data-flora": "breadcrumb"
  }, rest), navigation == null ? void 0 : navigation.map((nav, index) => {
    var _nav$as;

    var as = (_nav$as = nav.as) != null ? _nav$as : 'a';

    if (index === 0) {
      return /*#__PURE__*/React.createElement(Flex, {
        key: nav.text + "-" + nav.url,
        align: "center",
        as: "li"
      }, /*#__PURE__*/React.createElement(BreadcrumbItem, {
        as: as,
        href: nav.url
      }, /*#__PURE__*/React.createElement(NewIconHome, {
        size: 20,
        "aria-label": "In\xEDcio"
      })), /*#__PURE__*/React.createElement(ChevronRightIcon, {
        "aria-hidden": "true"
      }));
    }

    return index < navigation.length - 1 ? /*#__PURE__*/React.createElement(Flex, {
      key: nav.text + "-" + nav.url,
      align: "center",
      as: "li"
    }, /*#__PURE__*/React.createElement(Hidden, {
      from: "tablet"
    }, /*#__PURE__*/React.createElement(BreadcrumbItem, {
      as: as,
      href: nav.url,
      "aria-label": nav.text
    }, /*#__PURE__*/React.createElement(NewIconDots, null))), /*#__PURE__*/React.createElement(Hidden, {
      only: ['mobile']
    }, /*#__PURE__*/React.createElement(BreadcrumbItem, {
      as: as,
      href: nav.url
    }, nav.text)), /*#__PURE__*/React.createElement(ChevronRightIcon, {
      "aria-hidden": "true"
    })) : /*#__PURE__*/React.createElement(BreadcrumbItem, {
      key: nav.text + "-" + nav.url,
      as: "li",
      "aria-current": "page"
    }, nav.text);
  })));
};
//# sourceMappingURL=Breadcrumb.js.map